module.exports = __webpack_public_path__ + "static/media/Icn-cgi.98a2d116.svg";